<template>
  <div class="col-sm-4 details__thumb">
    <router-link :to="{ name: 'finishedAuctionsCatalog', query: { dzielo: artwork.slug, page: $route.query.page || FIRST_PAGE, q: $route.query.q }}" class="">
      <img :src="artwork.imagePreviewUrl" />
    </router-link>
  </div>
</template>

<script>
  import { FIRST_PAGE } from '@/shared/consts';

  export default {
    name: 'ArtworkImage',
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    created() {
      this.FIRST_PAGE = FIRST_PAGE;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/artwork/artwork_image.vue?46f9d4e7